import { types as api } from '@mesa-labs/mesa-api';
import { VendorApi } from '@mesa-labs/mesa-api/dist/apis/vendor';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders, useApi } from './api';

export const vendorCsvImportApi = createApi({
  reducerPath: 'vendorCsvImportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.vendorUrl,
    prepareHeaders,
  }),
  endpoints: (build) => ({

    uploadVendorCsv: build.mutation<
      api.VendorCsvImportUploadResponse,
      { partnerId: number; file: File }
    >({
      async queryFn({ partnerId, file }) {
        const vendorApi = useApi((options) => new VendorApi(CONFIG.api.vendorUrl, options));
        const formData = new FormData();
        formData.append('file', file);
        const data = await vendorApi.uploadVendorCsvForMatching(partnerId, formData);
        return { data: data! };
      },
    }),

    submitVendorCsvDecisions: build.mutation<
      api.VendorCsvImportDecisionsResponse,
      { partnerId: number; request: api.VendorCsvImportDecisionsRequest }
    >({
      async queryFn({ partnerId, request }) {
        const vendorApi = useApi((options) => new VendorApi(CONFIG.api.vendorUrl, options));
        const data = await vendorApi.submitVendorCsvMatchDecisions(partnerId, request);
        return { data: data! };
      },
    }),

  }),
});

export const {
  useUploadVendorCsvMutation,
  useSubmitVendorCsvDecisionsMutation,
} = vendorCsvImportApi;
